import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const WarnIcon = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 8v4M12 16h.01" />
  </svg>
);

const VerificationMarquee = () => {
  const { isPendingVerification, user } = useAuth();
  if (!isPendingVerification) return null;

  const isRejected = user?.verificationStatus === 'rejected';
  const linkClass = 'font-extrabold text-white underline decoration-white underline-offset-2 transition-opacity hover:opacity-85';

  const messageContent = isRejected ? (
    <>
      <WarnIcon />
      <span>
        <strong>Account verification rejected.</strong> One or more documents were rejected. Please review the reasons and re-upload in{' '}
        <Link to="/provider/settings" className={linkClass}>Settings</Link> to start applying for gigs.
      </span>
      <span className="mx-1 h-1 w-1 shrink-0 rounded-full bg-white/50" aria-hidden="true" />
    </>
  ) : (
    <>
      <WarnIcon />
      <span>
        <strong>Account pending approval.</strong> You can browse gigs but cannot apply until an admin approves your profile. Upload your documents in{' '}
        <Link to="/provider/settings" className={linkClass}>Settings</Link> to speed up the process.
      </span>
      <span className="mx-1 h-1 w-1 shrink-0 rounded-full bg-white/50" aria-hidden="true" />
    </>
  );

  return (
    <div
      className={`group relative w-full overflow-hidden border-b border-black/[0.08] ${
        isRejected
          ? 'bg-gradient-to-r from-red-500 to-red-700 text-white'
          : 'bg-gradient-to-br from-[#070F0B] to-[#132B1E] text-yellow-300'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex w-max animate-verification-marquee-mobile will-change-transform group-hover:[animation-play-state:paused] motion-reduce:animate-none md:animate-verification-marquee">
        <div className="flex shrink-0 items-center gap-2.5 whitespace-nowrap px-[30px] py-2 font-dm text-xs font-semibold tracking-[0.2px] [&_svg]:shrink-0 md:px-[60px] md:py-2.5 md:text-[13px]">{messageContent}</div>
        <div className="flex shrink-0 items-center gap-2.5 whitespace-nowrap px-[30px] py-2 font-dm text-xs font-semibold tracking-[0.2px] [&_svg]:shrink-0 md:px-[60px] md:py-2.5 md:text-[13px]" aria-hidden="true">{messageContent}</div>
      </div>
    </div>
  );
};

export default VerificationMarquee;
